import * as React from "react";
import "./styles.scss";
import { Theme } from "@vebox/etui-themes";
import { useTheme } from "@vebox/etui-system";
import { CensusCoolerContext } from "../../providers/CensusCollerProvider";
import { VeBoxCard } from "../../../../../components/card/VeBoxCard";
import { Display } from "../../../../../components/Display";
import {
	CENSUS_COOLER_STATUS_TEXTS,
	getStatusColor,
	StatusChip,
} from "../../components/CensusCoolerStatusChip";
import { ProgressBar } from "../../../../../components/ProgressBar";

interface CensusCoolerAnalysisProgressBarProps {
	count: number;
	total: number;
	updatingFrom: string;
	user: string;
	errorsLabel: string;
}

export const CensusCoolerAnalysisProgressBar: React.FC<
	CensusCoolerAnalysisProgressBarProps
> = ({ updatingFrom, total, user, count, errorsLabel }) => {
	const { AppTranslations } = React.useContext(CensusCoolerContext);
	const getText = () =>
		AppTranslations.readAndWrite.configurationStartedAt
			.replace("{0}", updatingFrom)
			.replace("{1}", user);
	const theme = useTheme();
	return (
		<VeBoxCard className={"cc-card"}>
			<VeBoxCard.Body className={"cc-card-body"}>
				<div className={"flx-row flx-space-between"}>
					<h2 className={"progress-bar-title"}>
						{AppTranslations.massiveActions.censusCooler.analysingEquipment}{" "}
						{count}/{total}
					</h2>
					<div className={"chip-container"}>
						<Display isVisible={errorsLabel !== ""}>
							<StatusChip
								status={CENSUS_COOLER_STATUS_TEXTS.ERROR}
								customLabel={errorsLabel}
							/>
						</Display>
						<Display isVisible={count === total && total !== 0}>
							<StatusChip status={CENSUS_COOLER_STATUS_TEXTS.COMPLETED} />
						</Display>
						<Display isVisible={count !== total}>
							<StatusChip status={CENSUS_COOLER_STATUS_TEXTS.IN_PROGRESS} />
						</Display>
					</div>
				</div>
				<ProgressBar
					bgColor={getStatusColor(
						CENSUS_COOLER_STATUS_TEXTS.IN_PROGRESS,
						theme as Theme,
					)}
					value={count ?? 0}
					max={total ?? 0}
				/>
				<div className={"flx-row flx-space-between"}>
					<p className={"progress-bar-footer-info"}>{getText()}</p>
				</div>
			</VeBoxCard.Body>
		</VeBoxCard>
	);
};
